module.exports = __webpack_public_path__ + "static/img/wlp1160.4f67d47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wlp1160.jpg
// module id = 3WoZ
// module chunks = 0